import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import DepartmentsTable from '../../components/departments/DepartmentsTable';

const DepartmentsArchive = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <DepartmentsTable isArchive />
    </WrapperSection>
);

export default DepartmentsArchive;
